// Alert Block - Similar to callout but simpler
class AlertBlock {
  static get toolbox() {
    return {
      title: 'Alert',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, config, api, readOnly }) {
    this.data = {
      type: data.type || 'info',
      text: data.text || ''
    };
    this.readOnly = readOnly;
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement('div');
    this._render();
    return this.wrapper;
  }

  _getStyles(type) {
    const styles = {
      info: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-200',
      success: 'bg-emerald-50 dark:bg-emerald-900/20 border-emerald-200 dark:border-emerald-800 text-emerald-800 dark:text-emerald-200',
      warning: 'bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-200',
      error: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800 text-red-800 dark:text-red-200'
    };
    return styles[type] || styles.info;
  }

  _render() {
    this.wrapper.innerHTML = `
      <div class="p-4 rounded-lg border ${this._getStyles(this.data.type)}" data-testid="alert-block">
        ${!this.readOnly ? `
          <select class="type-select text-xs px-2 py-1 mb-2 rounded border bg-white dark:bg-slate-800">
            <option value="info" ${this.data.type === 'info' ? 'selected' : ''}>Info</option>
            <option value="success" ${this.data.type === 'success' ? 'selected' : ''}>Success</option>
            <option value="warning" ${this.data.type === 'warning' ? 'selected' : ''}>Warning</option>
            <option value="error" ${this.data.type === 'error' ? 'selected' : ''}>Error</option>
          </select>
        ` : ''}
        <div class="alert-text" contenteditable="${!this.readOnly}" data-placeholder="Enter alert message...">${this.data.text}</div>
      </div>
    `;

    if (!this.readOnly) {
      const select = this.wrapper.querySelector('.type-select');
      const text = this.wrapper.querySelector('.alert-text');
      
      select?.addEventListener('change', (e) => {
        this.data.type = e.target.value;
        this._render();
      });
      
      text?.addEventListener('input', (e) => {
        this.data.text = e.target.innerHTML;
      });
    }
  }

  save() {
    return this.data;
  }
}

export default AlertBlock;
